import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../../lib/api-client';
import { Message } from '../types/Message';

export const useGetNewMessages = (userName: string) => {

    const { data, isLoading } = useQuery({
        queryKey: ['new-messages', userName],
        queryFn: async () => await apiClient.get('communication/new-messages') as Message[]
    });

    return {
        data: data || [],
        isLoading: isLoading
    };
};
